export default "__VITE_ASSET__BOtWN00o__"